var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 9 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.77.632a.5.5 0 0 1 .353-.147h.254a.513.513 0 0 1 .353.147l3.42 3.426a.333.333 0 0 1 0 .474l-.473.473a.327.327 0 0 1-.467 0L4.25 2.038 1.29 5.005a.333.333 0 0 1-.473 0L.35 4.532a.333.333 0 0 1 0-.474L3.77.632Z",
  fill: "#00546F"
})));
export default SvgArrow;